import React from "react";
import { Button, Tooltip } from "@mui/material";
import { Support } from "@mui/icons-material";
import { useWarehouseContext } from "../pallet/warehouse-context/warehouse-context-provider";
import { t } from "i18next";
import { freshdeskWidgetService } from "../../services/freshdesk-widget";

export const SupportTicketWidget = () => {
    const warehouseContext = useWarehouseContext();

    if (!warehouseContext.code) {
        return <></>;
    }

    return <>
        <Tooltip title={t("components.supportTicket.tooltip")}>
            <Button variant={"outlined"}
                    color={"inherit"}
                    onClick={() =>
                        freshdeskWidgetService.openWidget()
                    }
                    size={"large"}>
                <Support/>
            </Button>
        </Tooltip>
    </>;
};
